export const ActiveQuizKeyName = "activeQuizId";

export const getAllAnswersImagesUrls = (quizzes) => {
  let imagesArr = [];
  if (quizzes && Array.isArray(quizzes)) {
    quizzes.forEach((quiz) => {
      if (quiz.questions && Array.isArray(quiz.questions)) {
        quiz.questions.forEach((question) => {
          if (question.answers && Array.isArray(question.answers)) {
            question.answers.forEach((answer) => {
              if (answer.icon && answer.icon.imageUrl) {
                imagesArr.push(answer.icon.imageUrl);
              }
            });
          }
        });
      }
    });
  }

  return imagesArr;
};

export const getActiveQuizId = () => {
  return localStorage.getItem(ActiveQuizKeyName);
};

export const getActiveQuiz = (quizzes) => {
  let activeQuiz = null;
  let selectedQuiz = getActiveQuizId();
  if (quizzes) {
    activeQuiz = quizzes.find((quiz) => {
      return quiz._id === selectedQuiz;
    });
  }
  return activeQuiz;
};


